'use strict';

var _ = require('lodash');
var AppDispatcher = require('../core/AppDispatcher.jsx');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var Validators = require('../utils/Validators.js');
var Constants = require('../constants/AccountTypeConstants');
var ActionTypes = Constants.ActionTypes;
var ApplicationConstants = require('../constants/ApplicationConstants');
var ProductIds = ApplicationConstants.ProductIds;
var AccountTypeCodes = ApplicationConstants.AccountTypeCodes;
var ApplicationActionTypes = ApplicationConstants.ActionTypes;

var CHANGE_EVENT = 'change';

var _accountType, _productId;
var _accountTypeList = [];
var _errorList = [], _validationSummary = [];

function setAccountType(accountType) {
    _errorList = [];
    _validationSummary = [];
    _accountType = accountType;
}

function loadAccountTypes(accountTypes) {
    _accountTypeList = accountTypes;

    // show all account types when account type is already set i.e. for retrieve
    if (_accountType) {
        if (_accountTypeList && _accountTypeList.length > 0) {
            _.forEach(_accountTypeList, function(value) { value.isHidden = false });
        }
    }
}

function setProductId(productId) {
    _errorList = [];
    _validationSummary = [];
    _accountType = '';
    _productId = productId;
}

function validateAccountType() {
    var id = 'accountType';
    if (_productId !== ProductIds.SUPER && _productId !== ProductIds.PENSION) {
        var data = {accountType: _accountType};
        var rule = {accountType: 'required'};
        var customAttribute = {accountType: 'Account type'};
        _errorList = Validators.validateAll(data, rule, customAttribute, id);
        _validationSummary = Validators.validateAll(data, rule, customAttribute, id, 'Account type');
    }
}

var AccountTypeStore = assign({}, EventEmitter.prototype, {
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    /**
     * @param {function} callback
     */
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    /**
     * @param {function} callback
     */
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAccountTypeList: function () {
        return _accountTypeList;
    },
    getAccountType: function () {
        // In case of Super or Pension, the account type has to be Indivisual
        if (_productId === ProductIds.SUPER || _productId === ProductIds.PENSION) {
            return AccountTypeCodes.INDIVIDUAL;
        }

        return _accountType;
    },
    getErrorList: function () {
        return _errorList;
    },
    getSummaryErrorList: function(){
        return _validationSummary;
    },
    isValid: function () {
        return _errorList.length === 0;
    },
    getProductId: function() {
        return _productId;
    } 
});

AccountTypeStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ApplicationActionTypes.APPLICATION_SAVE_VALIDATE:
        case ApplicationActionTypes.VALIDATE_APPLICATION:
            validateAccountType();
            break;
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            setAccountType(action.applicationData.form.accountType);
            break;
        case ActionTypes.LOAD_ACCOUNT_TYPE_LIST:
            loadAccountTypes(action.accountTypes);
            break;
        case ActionTypes.SELECT_ACCOUNT_TYPE:
            setAccountType(action.accountType);
            break;
        default:
            return true;
    }

    // If action was responded to, emit change event
    AccountTypeStore.emitChange();
    return true;

});

module.exports = AccountTypeStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/AccountTypeStore.js